import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Brand } from "@/components/common/Brand";
import { jobs } from "@/api/mock/jobs";
export function Header() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";
  const highestHourlyPay = jobs.reduce(
    (highest, job) => Math.max(highest, job.salaryMax),
    0,
  );
  const salaryCurrency = jobs[0]?.salaryCurrency;
  const hourlyPayLabel =
    highestHourlyPay > 0 && salaryCurrency
      ? t("jobContent.salary.hourly", {
          amount: `${salaryCurrency} ${new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: salaryCurrency,
            maximumFractionDigits: 0,
          }).format(highestHourlyPay)}`,
        })
      : null;

  const handleApplyClick = () => {
    if (location.pathname === "/") {
      window.dispatchEvent(new Event("staywork:open-application"));
      return;
    }

    navigate("/#apply");
  };

  return (
    <header
      className={`sticky top-0 z-50 border-b backdrop-blur-xl ${
        isHomePage
          ? "border-transparent bg-slate-100/95"
          : "border-slate-200/80 bg-white/95"
      }`}
    >
      <div
        className={`mx-auto flex h-18 w-full items-center justify-between gap-3 px-4 py-3 sm:px-6 ${
          isHomePage
            ? "max-w-[48rem] bg-white shadow-[0_0_48px_rgba(15,23,42,0.12)]"
            : "container-shell"
        }`}
      >
        <Brand />
        {isHomePage && (
          <button
            type="button"
            onClick={() => navigate("/kyc")}
            className="animate-apply-heartbeat group inline-flex min-h-10 min-w-0 shrink-0 flex-col items-center justify-center rounded-xl bg-gold-400 px-2.5 py-1.5 text-navy-950 transition-colors hover:bg-[#ffd77e] sm:min-h-14 sm:px-5"
          >
            <span className="flex items-center gap-1 whitespace-nowrap text-[10px] font-extrabold sm:gap-1.5 sm:text-sm">
              {t("nav.applicationUrgency")}
              <ArrowRight className="size-4 shrink-0 transition-transform group-hover:translate-x-1" />
            </span>
          </button>
        )}
      </div>
    </header>
  );
}
